import React from 'react';
import PropTypes from 'prop-types';

// IDPUT
import TextFieldGroup from '../../../../../components/common/textFieldGroup/TextFieldGroup';

// VALIDATIONS
import isEmptyVAL from '../../../../../validations/checks/isEmptyVAL';

// UTILITIES
import { outputMasterUTL } from '../../../../../utils/outputMasterUTL';
import { transUTL } from '../../../../../utils/transUTL';

const VoterIdentificationNumberPhilippines = ({
  formState,
  selectedDataSources,
  handleOnChange,
  handleOnBlur,
  handleEnterKeyTrigger,
}) => {
  const { vin, errors } = formState;

  const inputElements = [
    {
      belongsTo: ['Philippines National ID'],
      element: (
        <TextFieldGroup
          key="vin"
          id="vin"
          type="text"
          name="vin"
          dataName="vinPH"
          labelClass="form-group__label"
          label={transUTL('translateFormOverview.inputLabels.vin')}
          value={vin}
          placeholder={transUTL('translatePlaceholder.inputPH.vin')}
          placeholderTrigger={isEmptyVAL(vin) ? 'input-empty' : ''}
          error={errors.vin}
          errorTrigger={errors.vin ? 'input-error' : ''}
          handleOnChange={handleOnChange}
          handleOnBlur={handleOnBlur}
          handleEnterKeyTrigger={handleEnterKeyTrigger}
        />
      ),
    },
  ];

  return (
    <div className="form-overview__form-inputs">
      {outputMasterUTL(selectedDataSources, inputElements)}
      <span />
    </div>
  );
};

VoterIdentificationNumberPhilippines.propTypes = {
  formState: PropTypes.object.isRequired,
  selectedDataSources: PropTypes.array.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleOnBlur: PropTypes.func.isRequired,
  handleEnterKeyTrigger: PropTypes.func.isRequired,
};

export default VoterIdentificationNumberPhilippines;
